import React from 'react';
import { isMobile } from 'react-device-detect';

import { isNudeDomain } from '../../utils/helpers';

import NakedNewsFooter from './NakedNewsFooter';
import NudeNewsFooter from './NudeNewsFooter';


const Footer = ({ location }) => {
  if (
    (location.pathname === '/dashboard/broadcast' ||
        location.pathname === '/chat') &&
        isMobile
  ) {
    return null;
  }

  return isNudeDomain ? <NudeNewsFooter /> : <NakedNewsFooter />;
};

export default Footer;
